import { SORT_ORDER } from '@/constants'
import apiClient from '@/lib/apiClient'
import type { SortingState } from '@tanstack/react-table'
import { endpoints } from './endPoint'

export type CreateTagPayload = {
  name: string
}

export const fetchTag = async (params: {
  limit?: number
  page?: number
  search?: string
  sort?: SortingState
}) => {
  try {
    const queryParams = new URLSearchParams()
    if (params.limit) queryParams.append('limit', params?.limit?.toString())
    if (params.page) queryParams.append('page', params?.page?.toString())
    if (params.search) queryParams.append('search', params?.search)
    if (params?.sort && params?.sort?.length > 0) {
      queryParams.append(
        'order',
        params?.sort?.[0].desc ? SORT_ORDER.DESC : SORT_ORDER.ASC
      )
    }
    if (params?.sort && params?.sort?.length > 0) {
      queryParams.append('orderOn', params?.sort?.[0].id || 'createdAt')
    }

    const response = await apiClient.get(
      `${endpoints.tag.getTags}?${queryParams.toString()}`
    )

    return response.data
  } catch (error) {
    console.error('Error fetching tags:', error)
    throw error
  }
}

export const createTag = async (payload: CreateTagPayload) => {
  try {
    const response = await apiClient.post(endpoints.tag.createTag, payload)
    return response.data
  } catch (error) {
    console.error('Error while creating tag:', error)
    throw error
  }
}

export const updateTag = async ({
  id,
  payload,
}: {
  id: string
  payload: CreateTagPayload
}) => {
  try {
    const response = await apiClient.put(endpoints.tag.updateTag(id), payload)
    return response.data
  } catch (error) {
    console.error('Error while updating tag:', error)
    throw error
  }
}

export const deleteTag = async (id: string) => {
  try {
    const response = await apiClient.delete(endpoints.tag.deleteTag(id))
    return response.data
  } catch (error) {
    console.error('Error while deleting tag')
    throw error
  }
}
